export enum ProfileTabs {
  About = "О компании",
  Notifications = "Уведомления",
  Integrations = "Интеграции",
  Team = "Команда",
  Promo = "Промо-коды",
  Security = "Безопасность"
}

/** Query `?tab=` в письмах и виджетах: lowercase-ключи, стабильнее русских лейблов. */
const PROFILE_TAB_QUERY: Record<string, ProfileTabs> = {
  about: ProfileTabs.About,
  notifications: ProfileTabs.Notifications,
  integrations: ProfileTabs.Integrations,
  team: ProfileTabs.Team,
  promo: ProfileTabs.Promo,
  security: ProfileTabs.Security,
}

export function profileTabFromQuery(raw: string | undefined | null): ProfileTabs | null {
  if (!raw) {
    return null
  }
  const key = String(raw).trim()
  const fromQuery = PROFILE_TAB_QUERY[key.toLowerCase()]
  if (fromQuery) {
    return fromQuery
  }
  if ((Object.values(ProfileTabs) as string[]).includes(key)) {
    return key as ProfileTabs
  }
  return null
}

export function profileTabToQuery(tab: ProfileTabs): string {
  const found = Object.entries(PROFILE_TAB_QUERY).find(([, value]) => value === tab)
  return found ? found[0] : 'about'
}

export const REALTY_SETUP_QUERY = "realty_setup"

export const IMPORT_REALTY_OBJECTS_CTA = "Импортировать объекты из Realty"

export function isRealtySetupQuery(raw: unknown): boolean {
  return raw === "1" || raw === true || raw === 1
}

export function realtySetupRouteParams() {
  return {
    tab: profileTabToQuery(ProfileTabs.Integrations),
    [REALTY_SETUP_QUERY]: "1",
  }
}
